export interface FormField {
  key: string;
  leadField?: 'name' | 'phone' | 'email' | 'message';
  type:
    | 'text'
    | 'email'
    | 'tel'
    | 'textarea'
    | 'name'
    | 'phone'
    | 'single_line'
    | 'multiline'
    | 'dropdown'
    | 'single_choice'
    | 'multiple_choice'
    | 'checkbox';
  label: string;
  required: boolean;
  position: number;
  placeholder?: string;
  options?: { label: string; value: string }[];
  separateFirstLast?: boolean;
  firstNameLabel?: string;
  lastNameLabel?: string;
  firstNamePlaceholder?: string;
  lastNamePlaceholder?: string;
  addOther?: boolean;
  otherLabel?: string;
  otherPlaceholder?: string;
  displayInTwoColumns?: boolean;
  settings?: Record<string, unknown>;
}

export function formFieldDescription(field: { settings?: Record<string, unknown> }) {
  const description = field.settings?.description;
  const descriptionEnabled = field.settings?.descriptionEnabled;

  if (descriptionEnabled === false || typeof description !== 'string') {
    return '';
  }

  return description.trim();
}

export function formFieldShowsRequiredIndicator(field: { required?: boolean }) {
  return Boolean(field.required);
}

export function formFieldPresentation(field: {
  required?: boolean;
  settings?: Record<string, unknown>;
}) {
  const helperText = formFieldDescription(field);

  return {
    helperText: helperText || undefined,
    showAsterisk: formFieldShowsRequiredIndicator(field),
  };
}
